module.exports = __webpack_public_path__ + "static/media/Mac_logo_logotype.6a84f798.png";